<div class="mb-24 flex">
  <button pdsButton="secondary" (click)="fetchLogs()" title="Reprocessar">
    <span class="icon">refresh</span>
    <span>Reprocessar</span>
  </button>
</div>
<peca-generic-logs-list [state]="logs$ | async" [settings]="settings$ | async" />
<pds-pagination [pagination]="pagination$" (paginate)="onPaginate($event)" />
